export default { // methods
    access(state) {
        return state.access;
    },
    Rol(state) {
        return state.Rol;
    },
    IdRol(state) {
        return state.IdRol;
    },
    NameCustomer(state) {
        return state.NameCustomer;
    },
    user(state) {
        return state.user;
    },
    loader(state) {
        return state.loader;
    }
}